<template>
    <v-container>
      <v-row>
        <v-col cols="12" class="pa-0 ma-0 mt-2">
          <v-text-field
            label="Owner Name"
            v-model="editedItem.ownerName"
            readonly
            class="input-text-size pa-0 mt-n1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
            <v-text-field
            label="Phone Number"
            v-model="editedItem.primaryPhone"
            class="input-text-size pa-0 mt-n1"
            type="tel"
            :rules="phoneRules"
            placeholder="(123) 456-7890"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
          <v-text-field
            label="Link"
            v-model="editedItem.url"
            readonly
            class="input-text-size pa-0 mt-n1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 mt-1">
          <span class="caption grey--text text--darken-1">
            {{ cartLinkTaxIdCount }} Tax ID{{ cartLinkTaxIdCount === 1 ? '' : 's' }} included in link
          </span>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
          <span
            class="caption d-block"
            :class="hasDroppedRecords ? 'warning--text' : 'grey--text text--darken-1'"
          >
            <template v-if="hasDroppedRecords">{{ selectedCount }} selected,
              {{ cartLinkTaxIdCount }} included in link. </template>A maximum of 10 tax
            records can be included in the SMS link, due to a character limit in the URL.
          </span>
        </v-col>
        <!-- this can be usefull later on -->
        <!-- <v-textarea class="input-text-size pa-0 ma-0" label="Body"
        outlined rows="4" dense v-model="editedItem.subjectBody" /> -->
      </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'SMSDialog',
  props: {
    baseCrudKey: {
      type: String,
      default: 'smsTransaction',
    },
  },
  data() {
    return {
      phoneRules: [
        (v) => !!v || 'Phone number is required',
        (v) => /^\+?1?\s*\(?-?\.?\s*\d{3}\)?[-.\s]*\d{3}[-.\s]*\d{4}$/.test(v) || 'Phone number must be valid (e.g., (123) 456-7890)',
      ],
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    /** Count of year:id pairs in cart link query (matches tax records in SMS URL). */
    cartLinkTaxIdCount() {
      const url = this.editedItem && this.editedItem.url;
      if (!url || typeof url !== 'string') {
        return 0;
      }
      const match = url.match(/[?&]items=([^&]*)/);
      if (!match) {
        return 0;
      }
      const raw = decodeURIComponent(match[1] || '');
      if (!raw.trim()) {
        return 0;
      }
      return raw.split(',').filter((segment) => segment.length > 0).length;
    },
    /** Records the user selected before the 160-character cap dropped any trailing ones. */
    selectedCount() {
      const count = this.editedItem && this.editedItem.selectedCount;
      return typeof count === 'number' ? count : this.cartLinkTaxIdCount;
    },
    hasDroppedRecords() {
      return this.selectedCount > this.cartLinkTaxIdCount;
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
  },
  watch: {
    'editedItem.primaryPhone': {
      handler: function formatPhoneNumber(value) {
        if (value) {
          const digits = value.replace(/\D/g, '');
          if (digits.length === 10) {
            const formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
            if (formatted !== value) {
              this.editedItem.primaryPhone = formatted;
            }
          }
        }
      },
    },
  },
};

</script>
